import GradientBackdrop from "../backgrounds/GradientBackdrop";

/** Same Vanta fog + radial wash as the home hero (`GradientBackdrop`). */
export default function CaseStudyVanta() {
  return <GradientBackdrop />;
}
